import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, ShieldCheck, Zap, Lock } from 'lucide-react';
import { Button } from './ui/Button';
export function PricingSection() {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 50
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          ...prev,
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-12 md:py-16 bg-white" data-id="element-174">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-175">
        <div className="text-center mb-8" data-id="element-176">
          <div className="inline-flex items-center justify-center gap-2 text-coral-600 font-bold text-sm mb-2" data-id="element-177">
            <Clock className="w-4 h-4" data-id="element-178" />
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </div>
          <div className="text-3xl font-bold font-heading text-teal-900 mb-2" data-id="element-179">
            {String(timeLeft.h).padStart(2, '0')}
            <span className="text-stone-400 mx-1" data-id="element-180">:</span>
            {String(timeLeft.m).padStart(2, '0')}
            <span className="text-stone-400 mx-1" data-id="element-181">:</span>
            {String(timeLeft.s).padStart(2, '0')}
          </div>
          <div className="text-sm text-stone-500 mb-6" data-id="element-182">
            ⚠️ Después sube $10.000 ARS. No vuelve.
          </div>

          <h2 className="text-3xl font-bold text-teal-900 mb-4" data-id="element-183">
            ELEGÍ TU SISTEMA
          </h2>

          <div className="max-w-xs mx-auto text-left" data-id="element-184">
            <div className="flex justify-between text-xs font-bold text-stone-500 mb-1" data-id="element-185">
              <span data-id="element-186">Cupos al precio de lanzamiento</span>
              <span data-id="element-187">72%</span>
            </div>
            <div className="h-2 bg-stone-200 rounded-full overflow-hidden" data-id="element-188">
              <motion.div initial={{
              width: 0
            }} animate={{
              width: '72%'
            }} transition={{
              duration: 1
            }} className="h-full bg-amber-500 rounded-full" data-id="element-189" />
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 items-start" data-id="element-190">
          {/* Base */}
          <div className="bg-white rounded-2xl p-6 shadow-sm border border-stone-200" data-id="element-191">
            <h3 className="text-xl font-bold text-teal-700 mb-1" data-id="element-192">
              📘 MÉTODO CONECTA-TEA — PLAN BASE
            </h3>
            <p className="text-sm text-stone-500 mb-4" data-id="element-193">5 Tomos + 5 Bonos</p>
            <p className="text-sm text-stone-600 mb-6" data-id="element-194">
              Ideal para empezar la comunicación visual con tu hijo con TEA.
            </p>

            <div className="flex items-baseline gap-2 mb-6" data-id="element-195">
              <span className="text-stone-400 line-through text-sm" data-id="element-196">
                $40.000
              </span>
              <span className="text-3xl font-bold text-teal-900" data-id="element-197">$19.990</span>
            </div>

            <Button variant="primary" className="w-full" href="https://tupuntodigital.shop/cart/46125310148781:1" data-id="element-198">
              QUIERO EL PLAN BASE
            </Button>
          </div>

          {/* Premium */}
          <div className="bg-white text-teal-900 rounded-2xl p-6 shadow-xl relative border border-amber-500/40" data-id="element-199">
            <div className="absolute -top-3 left-6 bg-amber-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-200">
              ⭐ EL MÁS ELEGIDO
            </div>
            <h3 className="text-xl font-bold text-amber-600 mb-1 mt-2" data-id="element-201">
              🏆 MÉTODO CONECTA-TEA + PROTOCOLO DE PAZ
            </h3>
            <p className="text-sm text-stone-500 mb-4" data-id="element-202">
              5 Tomos + 5 Bonos + Manual Maestro de Crisis
            </p>
            <p className="text-sm text-stone-600 mb-6" data-id="element-203">
              El sistema completo, con los protocolos para los momentos más
              difíciles.
            </p>

            <div className="flex items-baseline gap-2 mb-6" data-id="element-204">
              <span className="text-stone-400 line-through text-sm" data-id="element-205">
                $55.000
              </span>
              <span className="text-4xl font-bold text-teal-900" data-id="element-206">$27.990</span>
            </div>

            <Button variant="amber" className="w-full" href="https://tupuntodigital.shop/cart/46125322731693:1" data-id="element-207">
              QUIERO EL SISTEMA COMPLETO
            </Button>
          </div>
        </div>

        <div className="flex justify-center gap-4 mt-8 text-xs text-stone-500 font-medium" data-id="element-208">
          <div className="flex items-center" data-id="element-209">
            <ShieldCheck className="w-3 h-3 mr-1" data-id="element-210" /> Garantía 7 días
          </div>
          <div className="flex items-center" data-id="element-211">
            <Zap className="w-3 h-3 mr-1" data-id="element-212" /> Acceso inmediato
          </div>
          <div className="flex items-center" data-id="element-213">
            <Lock className="w-3 h-3 mr-1" data-id="element-214" /> Pago seguro
          </div>
        </div>
      </div>
    </section>;
}